import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { Link } from 'react-router-dom';
import { X, UserRound, Sparkles } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { useT } from '../context/LanguageContext';

const KEY = 'refuel_login_nudge';
const today = () => { const d = new Date(); return `${d.getFullYear()}-${d.getMonth() + 1}-${d.getDate()}`; };

const LoginNudge = ({ delay = 40000 }) => {
  const { user, loading } = useAuth();
  const { t } = useT();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (loading || user || localStorage.getItem(KEY) === today()) return;
    const id = setTimeout(() => setOpen(true), delay);
    return () => clearTimeout(id);
  }, [user, loading, delay]);

  const dismiss = () => { localStorage.setItem(KEY, today()); setOpen(false); };
  if (!open || user) return null;

  return createPortal(
    <div className="fixed inset-x-0 bottom-0 md:inset-auto md:bottom-6 md:right-6 z-[85] p-3 md:p-0" data-testid="login-nudge">
      <div className="relative md:w-[380px] rounded-3xl bg-[#0f0a17] border border-white/10 shadow-2xl p-6 animate-[fadeUp_0.35s_ease-out]">
        <button type="button" onClick={dismiss} aria-label="Lukk" data-testid="login-nudge-close" className="absolute top-3 right-3 w-9 h-9 rounded-full border border-white/15 text-white/70 flex items-center justify-center hover:border-[#ff2e2e] hover:text-[#ff2e2e]"><X size={16} /></button>
        <div className="w-12 h-12 rounded-2xl bg-[#ff2e2e]/15 text-[#ff2e2e] flex items-center justify-center mb-4"><Sparkles size={24} /></div>
        <h3 className="text-xl font-bold text-white mb-1.5" style={{ fontFamily: "'Oktah Round', sans-serif" }}>{t('Bli medlem – det er gratis')}</h3>
        <p className="text-white/60 text-sm mb-5">{t('Få medlemskort med QR-kode, lagre favorittvideoar og send inn bilete til galleriet.')}</p>
        <div className="flex gap-2">
          <Link to="/login" onClick={dismiss} data-testid="login-nudge-login-link" className="flex-1 inline-flex items-center justify-center gap-2 h-11 rounded-full bg-[#ff2e2e] text-black font-bold text-sm hover:bg-[#ff4d4d]"><UserRound size={16} /> {t('Logg inn')}</Link>
          <button type="button" onClick={dismiss} data-testid="login-nudge-later" className="px-4 h-11 rounded-full border border-white/15 text-white/70 text-sm font-semibold hover:border-white/40">{t('Seinare')}</button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default LoginNudge;
